<template>
  <div class="success-approval">
    <loading-primary v-if="isPageLoading"/>
    <div class="success-approval__wrapper" v-if="!invalidPage && !isPageLoading">
      <div class="success-approval__wrapper__svg">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <circle style="fill:#25AE88;" cx="25" cy="25" r="25"/>
          <polyline style="fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" points="
            38,15 22,33 12,25 "/>
        </svg>
      </div>
      <h2 class="title small-title">Success!</h2>
      <h6 class="description subhead">{{message}}</h6>
    </div>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-success-approval',
  components: {
    'loading-primary': LoadingPrimary,
    'loading-secondary': LoadingSecondary
  },
  props: {

  },
  data() {
    return {
      invalidPage: false,
      isPageLoading: false,
      status: null
    }
  },
  computed: {
    message () {
      if (this.status == 1) {
        return 'The requested content has been approved'
      } else {
        return 'The requested content has been rejected'
      }
    }
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { query } = this.$route
    if (query.approved && query.new_content_id && 
    query.temp_content_id && query.campaign_id) {
      this.status = query.approved
      this.changingApproval()
    } else {
      this.invalidPage = true
      this.handleInvalidPage()
    }
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    handleInvalidPage () {
      this.$notify({
        group: 'saved',
        title: 'Invalid Page',
        text: 'Invalid Page, redirecting...',
        type: 'danger'
      });
      setTimeout(() => {
        this.$router.push({name: 'home'})
      }, 2000);
    },
    changingApproval () {
      (async () => {
        const { approved, new_content_id, temp_content_id, campaign_id } = this.$route.query
        this.isPageLoading = true
        let data = {
          approved: approved,
          new_content_id: new_content_id,
          temp_content_id: temp_content_id
        }
        const response = await api.patch(apiV2.contentApproval(campaign_id), data, { needToken: true })
        if (response.status == 400) {
          this.$notify({
            group: 'saved',
            title: 'Bad Request',
            text: response.data.message,
            type: 'danger'
          })
        }
        this.isPageLoading = false
      })();
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>